const clearExpiredItems = () => {
  Object.keys(localStorage).forEach((id) => {
    if (Date.now() > localStorage[id]?.expire) {
      localStorage.removeItem(id);
    }
  });
};

export default clearExpiredItems;
